import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment";
import { ApiHttpService } from "./api-http.service";
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { InactivityService } from '../_helpers/inactivity-check-service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs'
import Swal from 'sweetalert2';
const { API_URL ,API_URLBLAZE} = environment;
const httpOptions = {
  headers: new HttpHeaders(
    { 
      'Content-Type': 'application/json',
      // returntype:"text"
     }
   

  )
};


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // private sseAbortController: AbortController | null = null;
  // private sseRetryCount: number = 0;
  // private readonly maxRetryAttempts: number = 5;

  constructor(private apiHttpService: ApiHttpService, private storageService: StorageService, private router: Router) {
  }

  login(username: string, password: string): Observable<any> {
    return this.apiHttpService.post(
      API_URL + '/token',
   //   'http://localhost:9091/mo-crm' + '/token',
      {
        username,
        password,
      },
      httpOptions
    );
  }

  loginNew(username: string, password: string): Observable<any> {
    return this.apiHttpService.post(
        API_URLBLAZE + '/user-management/auth/login',
      //  'http://localhost:8104/user-management/auth/login',
      {
        "userName" : username,
        "password" : password,
        "app" : "SHIELD_PORTAL"
      },
      httpOptions
    );
  }

  forgotPassword(username: string): Observable<any> {
    return this.apiHttpService.post(
      API_URL + '/forgetPassword',
      {
        userId: username,
      },
      httpOptions
    );
  }

  resetPassword(token: string, password: string): Observable<any> {
    return this.apiHttpService.post(
      API_URL + '/reset-password',
      {
        token,
        password
      },
      httpOptions
    );
  }

  requestResetPassword(emailId:string): Observable<any> {
    return this.apiHttpService.get(
      API_URLBLAZE + `/user-management/user/request-forgot-password?emailId=${emailId}`
      // `http://localhost:8104/user-management/user/request-forgot-password?emailId=${emailId}`
    );
  }

  verifyResetPasswordToken(emailId:string, token:string): Observable<any> {
    return this.apiHttpService.get(
      API_URLBLAZE + `/user-management/user/verify-token?emailId=${emailId}&token=${token}`
      // `http://localhost:8104/user-management/user/verify-token?emailId=${emailId}&token=${token}`
    );
  }

  confirmResetPassword(password: any, token:string, emailId : string): Observable<any> {
    return this.apiHttpService.post(
      API_URLBLAZE + `/user-management/user/reset-forgot-password`,
      // `http://localhost:8104/user-management/user/reset-forgot-password`,
      {
        "newPassword" : password,
        "emailId" : emailId,
        "token" : token
      }
    );
  }

  resetPasswordLogin(currentPassword: string, newPassword: string): Observable<any> {
    return this.apiHttpService.post(
      API_URLBLAZE + `/user-management/user/reset-password-internal`,
      {
        "oldPassword": currentPassword,
        "newPassword": newPassword
      },
      httpOptions
    );
  }

  resetPasswordForNewUser(password:String,token : String|null, emailId : String|null): Observable<any> {
    return this.apiHttpService.post(
      API_URL + '/user/setPassword',
      {
       "emailId":emailId,
       "password":password,
       "token":token
      },
      httpOptions
    );
  }

  resetPasswordForMobile(password:String,token : String|null, emailId : String|null): Observable<any> {
    return this.apiHttpService.post(
      API_URLBLAZE + '/user/verify-password-forget',
      {
       "emailId":emailId,
       "password":password,
       "token":token
      },
      httpOptions
    );
  }

  getProfile(): Observable<any> {
    return this.apiHttpService.get(
       API_URL + '/GetDetails',
      //'http://localhost:9091/mo-crm' + '/GetDetailsApi',
      httpOptions
    );
  }

  getUserProfileNew(): Observable<any> {
    return this.apiHttpService.get(API_URLBLAZE + '/user-management/role/menu', {});
  }

  register(username: string, email: string, password: string): Observable<any> {
    return this.apiHttpService.post(
      API_URL + 'auth/register',
      {
        username,
        email,
        password,
      },
      httpOptions
    );
  }

  logout(reason: string = 'manual') {
    console.log('🔓 Logout method called with reason:', reason);
    console.log('🌐 Environment API_URL:', environment.API_URL);
    
    // Make an HTTP call to log the logout activity
    const currentUser = this.storageService.getUserName();
    console.log('👤 Current user for logout:', currentUser);
    
    // Always make the logout API call for logging purposes, even if no user
    const logoutUrl = `${environment.API_URL}/auth/logout`;
    console.log('📡 Making logout request to:', logoutUrl);
    
    const logoutData = { 
      user: currentUser || 'unknown',
      timestamp: new Date().toISOString(),
      action: 'logout',
      reason: reason  // Add reason to distinguish manual vs inactivity logout
    };
    
    console.log('📦 Logout data:', logoutData);
    
    // Add a small delay to ensure the request is made before storage is cleared
    console.log('⏰ Starting HTTP request...');
    
    this.apiHttpService.post(logoutUrl, logoutData).subscribe({
      next: (response) => {
        console.log('✅ Logout activity logged successfully:', response);
        setTimeout(() => {
          console.log('🧹 Performing local logout after successful API call');
          this.performLocalLogout();
        }, 100); // Small delay to ensure logging completes
      },
      error: (error) => {
        console.error('❌ Failed to log logout activity:', error);
        console.error('🔍 Error details:', {
          status: error.status,
          statusText: error.statusText,
          url: error.url,
          message: error.message
        });
        // Always perform local logout even if API fails
        setTimeout(() => {
          console.log('🧹 Performing local logout after API error');
          this.performLocalLogout();
        }, 100);
      }
    });
  }

  private performLocalLogout() {
    // Close SSE connection before logout
    // this.closeNotificationStream();
    
    this.storageService.clean();
    console.log('🧹 Performing local logout after API error');

    // this.inactivityService.stopInactivityTracking();
    if (!this.storageService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
    }
  }

  setTrackingTimer(){
    // On login, start inactivity tracking
    // this.inactivityService.startInactivityTracking();
  }

  getTokenValidation(token:any) {
    return this.apiHttpService
  
      .get(
        `${API_URL}/registration-token?token=${token}`,{}
      );
  }

  getTokenValidationMobileApp(emailId:any,token:any) {
    return this.apiHttpService
  
      .get(
        `${API_URLBLAZE}/user/verify-token?emailId=${emailId}&token=${token}`,{}
      );
  }

  sendPasswordResetLink(emailId:any) {
    return this.apiHttpService
  
      .get(
        `${API_URLBLAZE}/user/password-forget?emailId=${emailId}`,{}
      );
  }

  getTokenByRefreshToken(token:any) {
    return this.apiHttpService
  
      .get(
        `${API_URLBLAZE}/user/password-forget?emailId=${token}`,{}
      );
  }

  refreshAccessToken(userData:any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+userData.accessToken,
      'x-refresh-token': userData.refreshToken
    });
    return this.apiHttpService.get(`${API_URLBLAZE}/auth/refresh`, { headers });
  }
  get2FASetup(username: string) {
    // 1. Call getToken() as a function (add parentheses)
    const token = this.storageService.getToken();
    
    // 2. Create headers correctly
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`  // Using template literal
    });
  
    // 3. Pass headers in the options object
    return this.apiHttpService.get(
       `${API_URLBLAZE}/mo-crm/2fa/setup?username=${username}`, 

     // `http://localhost:9091/mo-crm/2fa/setup?username=${username}`, 
      { 
        headers: headers,  // Include headers here
        responseType: 'blob' 
      }
    );
  }
  
  // Verify 2FA code
  verify2FACode(username: string, code: string): Observable<any> {

    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+this.storageService.getToken,
    });
    
      return this.apiHttpService.get(
        `${API_URLBLAZE}/mo-crm/2fa/verify?username=${username}&code=${code}`,
         // `http://localhost:9091/mo-crm/2fa/verify?username=${username}&code=${code}`,
          { headers }
      ).pipe(
          catchError(error => {
            console.error('Error verifying 2FA code:', error);
              return throwError(() => error);
          })
      );
  }

  // /**
  //  * Start SSE connection to monitor notifications after successful login
  //  */
  // startNotificationStream(): void {
  //   // Close existing connection if any
  //   this.closeNotificationStream();

  //   const token = this.storageService.getToken();
  //   if (!token) {
  //     console.error('❌ No access token available for SSE connection');
  //     return;
  //   }

  //   const sseUrl = `${API_URL}/notifications/stream`;

  //   // Reset retry count on new connection attempt
  //   this.sseRetryCount = 0;

  //   // Create AbortController for connection management
  //   this.sseAbortController = new AbortController();

  //   // Use fetch with ReadableStream to support Authorization header
  //   fetch(sseUrl, {
  //     method: 'GET',
  //     headers: {
  //       'Authorization': `Bearer ${token}`,
  //       'Accept': 'text/event-stream',
  //       'Cache-Control': 'no-cache'
  //     },
  //     signal: this.sseAbortController.signal
  //   }).then(response => {
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
      
  //     console.log('✅ SSE connection opened successfully');
  //     this.processSSEStream(response);
      
  //   }).catch(error => {
  //     if (error.name === 'AbortError') {
  //       console.log('🔌 SSE connection aborted');
  //       return;
  //     }
  //     console.error('❌ Failed to establish SSE connection:', error);
  //     this.scheduleReconnect();
  //   });
  // }

  // /**
  //  * Process SSE stream data
  //  */
  // private processSSEStream(response: Response): void {
  //   const reader = response.body?.getReader();
  //   const decoder = new TextDecoder();
    
  //   const readStream = () => {
  //     reader?.read().then(({ done, value }) => {
  //       if (done) {
  //         console.log('📡 SSE stream ended');
  //         this.scheduleReconnect();
  //         return;
  //       }
        
  //       const chunk = decoder.decode(value, { stream: true });
  //       console.log('📡 Raw SSE chunk received:', chunk);
  //       this.parseSSEChunk(chunk);
        
  //       // Continue reading
  //       readStream();
  //     }).catch(error => {
  //       if (error.name === 'AbortError') {
  //         console.log('🔌 SSE stream reading aborted');
  //         return;
  //       }
  //       console.error('❌ Error reading SSE stream:', error);
  //       this.scheduleReconnect();
  //     });
  //   };
    
  //   readStream();
  // }

  // /**
  //  * Parse SSE chunk data
  //  */
  // private parseSSEChunk(chunk: string): void {
  //   const lines = chunk.split('\n');
  //   let eventName = '';
  //   let eventData = '';
    
  //   for (const line of lines) {
  //     if (line.startsWith('data:')) {
  //       eventData = line.substring(5).trim();
  //       console.log("eventData:", eventData);
  //     } else if (line.trim() === '' && eventData) {
  //       // Empty line indicates end of event
  //       if (eventData && eventData !== '[DONE]') {
  //         console.log('📨 SSE message received:', eventData);
  //         console.log('🏷️ Event name:', eventName || 'unnamed');
  //         this.handleNotificationEvent(eventData);
  //       }
  //       // Reset for next event
  //       eventName = '';
  //       eventData = '';
  //     }
  //   }
    
  //   // Handle case where chunk doesn't end with empty line
  //   if (eventData && eventData !== '[DONE]') {
  //     console.log('📨 SSE message received:', eventData);
  //     console.log('🏷️ Event name:', eventName || 'unnamed');
  //     this.handleNotificationEvent(eventData);
  //   }
  // }

  // /**
  //  * Schedule reconnection attempt (max 5 times)
  //  */
  // private scheduleReconnect(): void {
  //   if (this.sseRetryCount >= this.maxRetryAttempts) {
  //     console.warn(`⚠️ SSE reconnection failed after ${this.maxRetryAttempts} attempts. Stopping reconnection attempts.`);
  //     return;
  //   }

  //   this.sseRetryCount++;
  //   console.log(`🔄 Scheduling SSE reconnection attempt ${this.sseRetryCount}/${this.maxRetryAttempts}...`);
    
  //   setTimeout(() => {
  //     if (this.storageService.isLoggedIn()) {
  //       console.log(`🔄 Attempting to reconnect SSE (${this.sseRetryCount}/${this.maxRetryAttempts})...`);
  //       this.connectSSE();
  //     }
  //   }, 5000);
  // }

  // /**
  //  * Handle incoming notification events
  //  */
  // private handleNotificationEvent(data: string): void {
  //   try {
  //     const notification = JSON.parse(data);
  //     console.log('🔔 Processing notification:', notification);

  //     // Check if this is a session termination notification
  //     if (notification.event === 'TERMINATED') {
        
  //       console.log('⚠️ Session termination notification received');
  //       this.showSessionTerminatedPopup();
  //     }
  //   } catch (error) {
  //     console.error('❌ Error parsing notification data:', error);
  //     // If it's a plain text message about session termination
  //     if (data.toLowerCase().includes('session') && data.toLowerCase().includes('terminated')) {
  //       console.log('⚠️ Session termination detected in plain text message');
  //       this.showSessionTerminatedPopup();
  //     }
  //   }
  // }

  // /**
  //  * Show popup notification for session termination and perform logout
  //  */
  // private showSessionTerminatedPopup(): void {
  //   Swal.fire({
  //     title: 'Session Terminated',
  //     text: 'Your session has been terminated as you logged in from another device/browser, click OK to relogin.',
  //     icon: 'warning',
  //     confirmButtonText: 'OK'
  //   }).then(() => {
  //     // Perform logout regardless of user response
  //     this.performLocalLogout();
  //   });
  // }

  // /**
  //  * Internal method to establish SSE connection
  //  */
  // private connectSSE(): void {
  //   const token = this.storageService.getToken();
  //   if (!token) {
  //     console.error('❌ No access token available for SSE reconnection');
  //     return;
  //   }

  //   // Close existing connection if any before creating new one
  //   if (this.sseAbortController) {
  //     this.sseAbortController.abort();
  //   }

  //   const sseUrl = `${API_URL}/notifications/stream`;
  //   this.sseAbortController = new AbortController();

  //   // Use fetch with ReadableStream to support Authorization header
  //   fetch(sseUrl, {
  //     method: 'GET',
  //     headers: {
  //       'Authorization': `Bearer ${token}`,
  //       'Accept': 'text/event-stream',
  //       'Cache-Control': 'no-cache'
  //     },
  //     signal: this.sseAbortController.signal
  //   }).then(response => {
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
      
  //     console.log('✅ SSE connection opened successfully');
  //     // Reset retry count on successful connection
  //     this.sseRetryCount = 0;
  //     this.processSSEStream(response);
      
  //   }).catch(error => {
  //     if (error.name === 'AbortError') {
  //       console.log('🔌 SSE connection aborted');
  //       return;
  //     }
  //     console.error('❌ Failed to establish SSE connection:', error);
  //     this.scheduleReconnect();
  //   });
  // }

  // /**
  //  * Close SSE connection
  //  */
  // private closeNotificationStream(): void {
  //   if (this.sseAbortController) {
  //     console.log('🔌 Closing SSE connection');
  //     this.sseAbortController.abort();
  //     this.sseAbortController = null;
  //   }
  //   // Reset retry count when manually closing
  //   this.sseRetryCount = 0;
  // }
}
